import { INVOICE_JOURNAL, INVOICE_VIEW, INVOICE_CREATOR } from './index'
import { registerRoute } from '@/router'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'
import { NavGroup, registerNavigationEntry } from '@/navigation'
import { registerHotkey } from '@/hotkeys/navigationHotkeys'
import { usePanelManager } from '@tritt/multipanel'
import { h } from 'vue'
import InvoiceCrumbs from '@/invoice/InvoiceCrumbs.vue'

const { registerNavigationCommand } = useContaCommand()
const { buildSimpleCrumb, registerBreadCrumbGetter } = useBreadCrumbs()

// Invoice Journal
const inv_jou_hotkey = 'r'
const label_journal = 'Fakturajournal'
const icon_journal = 'i-ph-files-fill'
registerNavigationCommand({
    route: INVOICE_JOURNAL,
    label: label_journal,
    icon: icon_journal,
    hotkey: inv_jou_hotkey
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: label_journal,
    key: 'invoice-journal',
    icon: icon_journal,
    target: INVOICE_JOURNAL,
    sortOrder: 1
})
registerRoute(INVOICE_JOURNAL)
registerHotkey(inv_jou_hotkey, INVOICE_JOURNAL)
buildSimpleCrumb(INVOICE_JOURNAL, label_journal, icon_journal, true)


// Invoice View
registerRoute(INVOICE_VIEW)
registerBreadCrumbGetter(() => {
    const { currentPanelContent } = usePanelManager()
    if (currentPanelContent.value?.componentName !== INVOICE_VIEW.componentName) {
        return
    }
    return h(InvoiceCrumbs, {
        invoiceUuid: currentPanelContent.value?.props.invoiceUuid,
    })
})

// Invoice Creator
const creatorHotkey = 'd'
const label_creator = 'Ny faktura'
const label_icon = 'i-ph-file-plus'
registerNavigationCommand({
    route: INVOICE_CREATOR,
    label: label_creator,
    icon: label_icon,
    hotkey: creatorHotkey
})

registerNavigationEntry(NavGroup.CREATE_ENTRY, {
    title: label_creator,
    key: 'invoice-creator',
    icon: label_icon,
    target: INVOICE_CREATOR
})
registerRoute(INVOICE_CREATOR)
registerHotkey(creatorHotkey, INVOICE_CREATOR)
buildSimpleCrumb(INVOICE_CREATOR, label_creator, label_icon)
